import Yup from '~/util/yup';

export const verificationValidationSchema = Yup.object().shape({
	ethnicityIds: Yup.array()
		.label('Ethnicity')
		.of(Yup.string())
		.test('valid', 'Invalid selection.', function (val: (string | undefined)[] | undefined) {
			if (!val) {
				return true;
			}
			if (val.indexOf('7') >= 0 && val.length > 1) {
				return false;
			} else if (val.indexOf('1') >= 0 && (val.indexOf('2') >= 0 || val.indexOf('3') >= 0 || val.indexOf('4') >= 0 || val.indexOf('5') >= 0)) {
				return false;
			}
			return true;
		})
		.nullable()
		.min(1, '${label} is required.'),
	raceIds: Yup.array()
		.label('Race')
		.of(Yup.string())
		.test('valid', 'Invalid selection.', function (val) {
			if (!val) {
				return true;
			}
			if (val.indexOf('16') >= 0 && val.length > 1) {
				return false;
			} else if (val.indexOf('17') >= 0 && val.length > 1) {
				return false;
			}
			return true;
		})
		.nullable()
		.min(1, '${label} is required.'),
	primaryLanguageId: Yup.string().label('Primary Language').nullable().required(),
	needsInterpreterId: Yup.string().label('Needs Interpreter').nullable().required(),
	emailAddress: Yup.string().label('Email Address').nullable().email(),
	religionId: Yup.string().label('Religion').nullable(),
	mainPhoneNumber: Yup.string().label('Main Phone Number').nullable().required(),
	alternatePhoneNumber: Yup.string().label('Alternate Phone Number').nullable(),
	educationLevelId: Yup.string().label('Education Level').nullable(),
	maritalStatusId: Yup.string().label('Marital Status').nullable()
});

export const dataEntryValidationSchema = Yup.object().shape({
	ethnicityIds: Yup.array()
		.label('Ethnicity')
		.of(Yup.string())
		.test('valid', 'Invalid selection.', function (val: (string | undefined)[] | undefined) {
			if (!val) {
				return true;
			}
			if (val.indexOf('7') >= 0 && val.length > 1) {
				return false;
			} else if (val.indexOf('1') >= 0 && (val.indexOf('2') >= 0 || val.indexOf('3') >= 0 || val.indexOf('4') >= 0 || val.indexOf('5') >= 0)) {
				return false;
			}
			return true;
		})
		.nullable(),
	raceIds: Yup.array()
		.label('Race')
		.of(Yup.string())
		.test('valid', 'Invalid selection.', function (val) {
			if (!val) {
				return true;
			}
			if (val.indexOf('16') >= 0 && val.length > 1) {
				return false;
			} else if (val.indexOf('17') >= 0 && val.length > 1) {
				return false;
			}
			return true;
		})
		.nullable(),
	primaryLanguageId: Yup.string().label('Primary Language').nullable(),
	needsInterpreterId: Yup.string().label('Needs Interpreter').nullable(),
	emailAddress: Yup.string().label('Email Address').nullable().email(),
	religionId: Yup.string().label('Religion').nullable(),
	mainPhoneNumber: Yup.string().phoneNumber().label('Main Phone Number').nullable().required(),
	alternatePhoneNumber: Yup.string().phoneNumber().label('Alternate Phone Number').nullable(),
	educationLevelId: Yup.string().label('Education Level').nullable(),
	maritalStatusId: Yup.string().label('Marital Status').nullable(),
	secondaryLanguageId: Yup.string().label('Secondary Language').nullable()
});
